<body>
  <div class="container">
    <router-outlet></router-outlet>
    <!--<app-footer></app-footer>-->
    <app-chat></app-chat>
  </div>
  <app-footer></app-footer>
  <app-toast-container></app-toast-container>
</body>



<!--<h1 id="tableLabel">Weather forecast</h1>

<p>This component demonstrates fetching data from the server.</p>-->

<!--<p *ngIf="!forecasts"><em>Loading... Please refresh once the ASP.NET backend has started. See <a href="https://aka.ms/jspsintegrationangular">https://aka.ms/jspsintegrationangular</a> for more details.</em></p>-->

<!--<table>
    <thead>
        <tr>
            <th>Date</th>
            <th>Temp. (C)</th>
            <th>Temp. (F)</th>
            <th>Summary</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let forecast of forecasts">
            <td>{{ forecast.Date }}</td>
            <td>{{ forecast.TemperatureC }}</td>
            <td>{{ forecast.TemperatureF }}</td>
            <td>{{ forecast.Summary }}</td>
        </tr>
    </tbody>
</table>-->
